import { render, staticRenderFns } from "./lpr.vue?vue&type=template&id=940833e4&scoped=true"
import script from "./lpr.vue?vue&type=script&lang=js"
export * from "./lpr.vue?vue&type=script&lang=js"
import style0 from "./lpr.vue?vue&type=style&index=0&id=940833e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940833e4",
  null
  
)

export default component.exports